/**
 * The app's outermost layout route: the page (MainLayout or the book reader's own layout) and
 * the one fixed audio player. Keeping the player here, outside both layouts, means switching
 * between them never unmounts its <audio> element, so opening the reader never stops a session
 * that is playing (ebook-plan § 3.13, critic CR-6).
 */
import { Outlet } from 'react-router-dom';
import { FixedAudioPlayer } from './FixedAudioPlayer';

export function AppShell() {
  return (
    <>
      <Outlet />
      <FixedAudioPlayer />
    </>
  );
}
